module.exports = __webpack_public_path__ + "img/EgyptTechCamelRider2_ua.322d0d1c.webp";